module.exports = __webpack_public_path__ + "img/icon-light-tasks-white.583a468f.svg";